import { request } from "../../../Services/Api"

// Expected admin Digital receipt endpoints. They do not exist on the backend yet,
// so the saga falls back to dummy data when these fail (see saga.js + dummyData.js).
export const getDigitalReceiptRequests = (params) =>
  request.api.get("/user/requests/digital_receipt/", params)

export const updateDigitalReceiptStatus = ({ id, ...params }) =>
  request.api.patch(`/user/requests/digital_receipt/${id}/`, params)

export const reviewDigitalReceiptUpdate = ({ id, action, ...params }) =>
  request.api.post(`/user/requests/digital_receipt/${id}/${action}/`, params)
